export default __webpack_public_path__ + "static/media/Browser-compatibility.b548cc34.png";